module.exports = __webpack_public_path__ + "img/category.9ed7b5d1.svg";